import { useState } from 'react';
import { color } from '../../../app/theme';

const IconTableSortDown = ({ style = { marginRight: 4 } }) => {
  const [isHover, setIsHover] = useState(false);

  const randomA = Math.random();
  const randomB = Math.random();

  return (
    <>
      <svg
        onMouseEnter={() => {
          setIsHover(true);
        }}
        onMouseLeave={() => {
          setIsHover(false);
        }}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="16"
        height="16"
        style={style}
      >
        <defs>
          <path
            id={randomA}
            d="m4.588 9.349 3.414 2.926 3.414-2.926a.659.659 0 0 1 .858 1L8.43 13.643a.659.659 0 0 1-.858 0L3.73 10.35a.659.659 0 0 1 .858-1zm2.985-6.99a.659.659 0 0 1 .858 0l3.843 3.294a.659.659 0 0 1-.858 1L8.002 3.727 4.588 6.653a.659.659 0 0 1-.858-1z"
          />
        </defs>
        <g fill="none" fillRule="evenodd">
          <mask id={randomB} fill="#fff">
            <use xlinkHref={`#${randomA}`} />
          </mask>
          <use
            fill={isHover ? color.$10 : color.$9}
            fillRule="nonzero"
            xlinkHref={`#${randomA}`}
          />
          <g fill={isHover ? color.$10 : color.$9} mask={`url(#${randomB})`}>
            <path d="M0 0h16v16H0z" />
          </g>
        </g>
      </svg>
    </>
  );
};

export default IconTableSortDown;
